import { T } from '@tribeplatform/react-components/i18n'

import type { TableCounterProps } from './types.js'

export const InvitationsCounter = ({
  matchedCount,
  totalCount,
}: TableCounterProps) => {
  return (
    <div className="flex items-center space-s-1">
      {totalCount === matchedCount ? (
        <span className="font-medium">
          <T
            defaultMessage="{invitations_count, plural, zero {No invitations} one {# invitation} other {# invitations}}"
            id="Generics.Invitations.Plural"
            values={{
              invitations_count: totalCount,
            }}
          />
        </span>
      ) : (
        <span>
          <T
            defaultMessage="<bold>{matched_count, plural, one {# invitation} other {# invitations}} matched</bold> of {total_count, number}"
            id="Admin.InvitationsList.TableCounter"
            values={{
              matched_count: matchedCount,
              total_count: totalCount,
              bold: chunks => <span className="font-medium">{chunks}</span>,
            }}
          />
        </span>
      )}
    </div>
  )
}
